import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { FakVrstaTroska } from './fak-vrsta-troska';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-fak-vrsta-troska-update',
  templateUrl: './fak-vrsta-troska-update.component.html'
})
export class FakVrstaTroskaUpdateComponent extends BaseUpdateComponent<FakVrstaTroska> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
){
    super(activatedRoute, baseDataService, toastrService, translateService);
}

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Naziv',Validators.required, 'required', 'FAKVRSTATROSKA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc('Naziv',Validators.maxLength(50), 'maxlength', 'FAKVRSTATROSKA.NAZIV.VALIDATION.MAXLENGTH');

  }

}
